module.exports = __webpack_public_path__ + "static/img/img_p3_1_code.1a9f1b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p3_1_code.png
// module id = ZNKi
// module chunks = 1